import { IArcPlanStatus, ISubagentStatus } from '@common/interfaces/atlasai'
import { IRootState } from '../reducer'
import { prefix } from './actions'

/**
 * What is left of the Arc chat store.
 *
 * A conversation with Arc is a channel now, so its messages, sessions, drafts,
 * unread counts and model choice all live in `redux/channels`. This slice keeps
 * only the things that are genuinely about the agent rather than about the
 * conversation carrying it: the live plan and subagent panels, the approval gate,
 * and the recipient picker the Automations page uses.
 */
const getAtlasAIState = (state: IRootState) => state[prefix]

const EMPTY_SUBAGENTS: ISubagentStatus[] = []

/** Live subagent statuses for a session (empty when none are active). */
export const subagentsForSession = (
  state: IRootState,
  targetSessionId: string | null | undefined,
): ISubagentStatus[] =>
  (targetSessionId && getAtlasAIState(state).subagents[targetSessionId]) || EMPTY_SUBAGENTS

/** The session's live multi-step plan, or null when it has none in flight. */
export const planForSession = (
  state: IRootState,
  targetSessionId: string | null | undefined,
): IArcPlanStatus | null =>
  (targetSessionId && getAtlasAIState(state).plan[targetSessionId]?.plan) || null

/** A notification click asking the floating bubble to open a conversation. */
export const messagesChannelRequest = (state: IRootState) =>
  getAtlasAIState(state).messagesChannelRequest

/** A preview card's Message, asking AIM to open a new direct message draft. */
export const messagesDmRequest = (state: IRootState) => getAtlasAIState(state).messagesDmRequest

// Pending approvals (WRITE_DANGEROUS gate)
export const pendingApprovals = (state: IRootState) =>
  getAtlasAIState(state).pendingApprovals.pending
export const approvalsResolving = (state: IRootState) =>
  getAtlasAIState(state).pendingApprovals.resolving

// All that is left of session sharing: the Automations page picks recipients with
// this. Sharing a conversation is a channels concern now.
export const inviteableUsers = (state: IRootState) =>
  getAtlasAIState(state).inviteableUsers?.data ?? []
